export default {"src":"/_next/static/media/LeftArrow.60f123f0.svg","height":13,"width":8,"blurWidth":0,"blurHeight":0};